import { Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { CustomDatepickerSelectedComponent } from '@shared/components/custom-datepicker-selected/custom-datepicker-selected.component';
import { StringUtils } from '@shared/helpers/StringUtils';
import { TipoArquivoProntuarioList } from '@shared/model/tipo-arquivo-prontuario-enum.model';
import { TipoConsultaList } from '@shared/model/tipo-consulta-enum.model';
import { AgendaDto, AgendaServiceProxy, AnexoConsultaDto, ConsultaServiceProxy, ConvenioDto, ConvenioServiceProxy, DiaLivreDto, EventoServiceProxy, HorarioLivreDto, TipoConsultaEnum, TipoUsuarioEnum, UpdateConsultaDto } from '@shared/service-proxies/service-proxies';
import { DataService } from '@shared/services/data.service';
import * as moment from 'moment';

@Component({
  selector: 'app-remarcar-consulta',
  templateUrl: './remarcar-consulta.component.html',
  styleUrls: ['./remarcar-consulta.component.scss']
})
export class RemarcarConsultaComponent extends AppComponentBase implements OnInit {

  public tipoConsulta: TipoConsultaList = new TipoConsultaList();
  public teleConsulta = TipoConsultaEnum._1
  public saving: boolean = false;
  public horaConsulta: string;
  public dataConsulta: string;
  public convenios: ConvenioDto[] = [];
  public dataAtual: string = moment().format("YYYY-MM-DD");
  public newAnexo: AnexoConsultaDto = new AnexoConsultaDto();
  public tipoArquivo: TipoArquivoProntuarioList = new TipoArquivoProntuarioList();
  public diasDisponiveis: string[] = [];
  public horariosDisponiveis: HorarioLivreDto[] = [];
  protected agendas: AgendaDto[] = [];
  protected horarioSelecionado: HorarioLivreDto = new HorarioLivreDto();
  private datasDisponivies: DiaLivreDto[] = [];
  private availableDates: Date[];

  @ViewChild('file') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('datePicker') datePickerInput!: CustomDatepickerSelectedComponent;

  @Input() consulta: UpdateConsultaDto = new UpdateConsultaDto();
  @Input() tipoUsuario: TipoUsuarioEnum;
  @Output() onSave = new EventEmitter<any>();

  constructor(
    injector: Injector,
    public bsModalRef: BsModalRef,
    private readonly _consultaService: ConsultaServiceProxy,
    private readonly _convenioService: ConvenioServiceProxy,
    private readonly _eventoService: EventoServiceProxy,
    private readonly _dataService: DataService,
    private readonly _agendaService: AgendaServiceProxy,
  ) { super(injector) }

  ngOnInit(): void {
    this.getAgenda();
    this.getConvenios();
    this.horaConsulta = null;
    this.dataConsulta = null;  
    this.consulta.novosAnexos = [];
    this.consulta.anexosRemovidos = [];
  }

  protected save(): void {
    this.saving = true;
    this.consulta.dataConsulta = this._dataService.combinarDataHora(this.dataConsulta, this.horaConsulta);
    if (this.consulta.tipoConsulta != this.teleConsulta) this.consulta.linkTeleconsulta = null;
    if (!this.isFormValided()) {
      this.saving = false;
      return;
    }
    abp.ui.setBusy();
    this._consultaService.remarcarConsulta(this.consulta).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.onSave.emit();
      this.bsModalRef.hide();
    });
  }

  private isFormValided(): boolean {
    var validations = [
      { condition: StringUtils.isNullOrEmpty(this.dataConsulta), message: "Informe a data da consulta." },
      { condition: StringUtils.isNullOrEmpty(this.horaConsulta), message: "Informe o horário da consulta." },

    ];

    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }

 protected getHorariosDisponiveis(): void {
    this.horariosDisponiveis = [];
    this.horarioSelecionado = new HorarioLivreDto();
    this.horariosDisponiveis = [...this.datasDisponivies.find(x => x.data.format("DD/MM/YYYY") == this.dataConsulta).horarios];
  }


  protected setHorario(): void {
    this.horaConsulta = this.horarioSelecionado.horaInicio;
    this.consulta.agendaId = this.horarioSelecionado.agendaId;
  }

  protected setDataConsulta(data: string): void {
    this.horariosDisponiveis = [];
    this.dataConsulta = moment(data).format("DD/MM/YYYY");
    this.getHorariosDisponiveis();
  }

  protected atualizarDatasDisponiveis(datas: moment.Moment[]): void {
    if (datas)
      this.getDatasDisponiveis(datas[0], datas[1]);
  }

  protected selecionarAgenda(): void {
    if (this.consulta.agendaId) {
      this.getDatasDisponiveis(moment().startOf('month'), moment().endOf('month'));
      this.datePickerInput.dataConsulta = null;
      this.horariosDisponiveis = [];
      this.diasDisponiveis = [];
    }
  }

  protected getAgenda(): void {
    abp.ui.setBusy();
    this._agendaService.getAgendaProfissional(this.consulta.profissionalId, this.appSession.clinicaId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.agendas = result;
    });
  }

  private getDatasDisponiveis(dataInicio: moment.Moment, dataFim: moment.Moment, getHorario: boolean = false): void {
    abp.ui.setBusy();
    this._eventoService.getHorariosDisponiveisPorDia(this.consulta.profissionalId, this.appSession.clinicaId, dataInicio, dataFim, this.consulta.agendaId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.datasDisponivies = result;
      const mapa = new Map<string, moment.Moment>();

      for (const item of result) {
        const dataChave = item.data.format('YYYY-MM-DD');
        if (!mapa.has(dataChave)) {
          mapa.set(dataChave, item.data);
        }
      }
      let datas = Array.from(mapa.values()).map(m => m.format('DD/MM/YYYY'))
      this.availableDates = datas.map(dateStr => {
        const [day, month, year] = dateStr.split('/').map(Number);
        return new Date(year, month - 1, day);
      });
      this.datePickerInput.updateDatas(this.availableDates);
      if (getHorario)
        this.getHorariosDisponiveis();
    });
  }

  protected getConvenios(): void {
    abp.ui.setBusy();
    this._convenioService.getConvenios().pipe(
      finalize(() => {
        abp.ui.clearBusy()
      })
    ).subscribe((result) => {
      this.convenios = result;
    })
  }
}
